/**
 * MySQL `DATETIME` as `YYYY-MM-DD HH:mm:ss` (local wall time).
 * @param {string|Date|null|undefined} value
 * @returns {string|null}
 */
export function toMysqlDateTime(value) {
  if (value == null || value === "") return null;
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const pad = (n) => String(n).padStart(2, "0");
    return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())} ${pad(
      value.getHours(),
    )}:${pad(value.getMinutes())}:${pad(value.getSeconds())}`;
  }
  let s = String(value).trim();
  s = s.replace(/Z$/i, "");
  s = s.replace(/\.\d+$/, "");
  if (s.includes("T")) {
    const [d, tRaw = ""] = s.split("T");
    let t = tRaw.slice(0, 8);
    if (t.length === 5) t = `${t}:00`;
    if (!t) t = "00:00:00";
    return `${d} ${t}`;
  }
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(s)) return `${s}:00`;
  return s;
}
